/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';

/**
 * 
 * @export
 * @interface PopiaStatusViewModel
 */
export interface PopiaStatusViewModel {
    /**
     * 
     * @type {string}
     * @memberof PopiaStatusViewModel
     */
    popiaStatus: string;
    /**
     * 
     * @type {number}
     * @memberof PopiaStatusViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof PopiaStatusViewModel
     */
    partyType: IAPPARTYTYPE;
}

/**
 * Check if a given object implements the PopiaStatusViewModel interface.
 */
export function instanceOfPopiaStatusViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "popiaStatus" in value;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "partyType" in value;

    return isInstance;
}

export function PopiaStatusViewModelFromJSON(json: any): PopiaStatusViewModel {
    return PopiaStatusViewModelFromJSONTyped(json, false);
}

export function PopiaStatusViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopiaStatusViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'popiaStatus': json['PopiaStatus'],
        'partyId': json['PartyId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
    };
}

export function PopiaStatusViewModelToJSON(value?: PopiaStatusViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PopiaStatus': value.popiaStatus,
        'PartyId': value.partyId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
    };
}

